import { supabase } from '../supabaseClient'
import { isNodeOffline } from '../models/useNode'

/**
 * Whether one node is online now, read from its row. Null when the row cannot be read.
 *
 * ⚠ A read of the ROW, not of the node store: the store holds the active org's nodes only, and a
 * registration may put the node in another org.
 */
export const readNodeOnline = async (nodeId: string): Promise<boolean | null> => {
  const { data, error } = await supabase.from('nodes').select('online_at, offline_at').eq('id', nodeId).maybeSingle()
  if (error || !data) {
    if (error) console.warn('register: cannot read the node', error)
    return null
  }
  return !isNodeOffline({ onlineAt: data.online_at, offlineAt: data.offline_at })
}
